import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted } from 'vue';

import { faTimes, faAngleLeft } from '@fortawesome/free-solid-svg-icons';

import { useConstantStore } from '@/helpers/composables/useStores';


export default /*#__PURE__*/_defineComponent({
  __name: 'NewDesignModal',
  props: {
    title: { default: '' },
    closable: { type: Boolean, default: true },
    hasBack: { type: Boolean },
    hasHeader: { type: Boolean, default: true },
    showDefaultTitle: { type: Boolean, default: true },
    hasLargeToolbar: { type: Boolean, default: true },
    onWillDismiss: { type: Function, default: () => Promise.resolve() }
  },
  emits: ['back', 'closed', 'dismiss'],
  setup(__props: any, { emit }) {

const props = __props as { title: string, closable: boolean, hasBack?: boolean, hasHeader: boolean, showDefaultTitle: boolean, hasLargeToolbar: boolean, onWillDismiss: () => Promise<void> };





const ASSETS_DIRECTORY = `/${ASSETS_DIR}`;

const { providers } = useConstantStore();

onMounted(async () => {
	await props?.onWillDismiss();
	emit('closed');
});

const descriptionProviderList = computed(() => {
	return providers
		.value()
		.slice(0, 3)
		.map(({ clearName }: any) => ` ${clearName}`);
});

return { __sfc: true,props, emit, ASSETS_DIRECTORY, providers, descriptionProviderList, faTimes, faAngleLeft }
}

})